var ctrlopt = ctrlopt;

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var time_interval = Drupal.settings.globals_variables.appointment_booking_time_interval !== 'undefined' ? Drupal.settings.globals_variables.appointment_booking_time_interval : 0;
  var special_timeformat = Drupal.settings.globals_variables.oab_calendar_french_date_format !== 'undefined' ? Drupal.settings.globals_variables.oab_calendar_french_date_format : 0;
  var oab_override_date_format = Drupal.settings.globals_variables.oab_override_date_format !== 'undefined' ? Drupal.settings.globals_variables.oab_override_date_format : 0;
  var settings = Drupal.settings.globals_variables || {};
  var oab_date_time_override = settings.oab_date_time_override || 0;
  var oab_hk_zh_dateformat_lang = settings.oab_hk_zh_dateformat_lang || 0;
  var oabDateFormat = settings.oabDateFormat || 0;
  var oab_show_country_on_confirm = settings.oab_show_country_on_confirm || 0;
  var oab_date_time_format_change = settings.oab_date_time_format_change || 0;
  var appointment_booking_japan_date_format = settings.appointment_booking_japan_date_format || 0;

  /* Concrete View */
  apptBook.ConfirmSection = function (container) {
    apptBook.ConfirmSection.superclass.constructor.call(this);
    this.id = 'confirmation';
    this.container = container;
    this.confContainer = container.find('.confirmation-container');
    this.lessons = this.confContainer.find('.your-lessons');
    this.lesson = this.lessons.find('.lesson').remove();
    this.location = this.confContainer.find('.location');
    this.dateTime = this.confContainer.find('.date-time');
    this.artistName = this.confContainer.find('.artist');
    this.minLabel = this.container.attr('data-minutes-label');
    this.lessonsSeparator = this.container.attr('data-lessons-separator');
    this.months = this.container.attr('data-month-names').split(',');
    this.yearSuffix = this.container.attr('data-year-suffix');
    this.daySuffix = this.container.attr('data-day-suffix');
    this.monthSuffix = this.container.attr('data-month-suffix');
    this.amSuffix = this.container.attr('data-am-suffix');
    this.pmSuffix = this.container.attr('data-pm-suffix');
    this.productLessonIds = container.find('.your-lessons').attr('lesson-ids').split(',');
    this.productLessonUrls = container.find('.your-lessons').attr('product-urls').split(',');
    this.productCTAText = container.find('.your-lessons').attr('product-cta');
    this.totalDuration = 0;
    this.isVirtual = 0;
  };

  ctrlopt.extend(apptBook.ConfirmSection, apptBook.AbstractSection);

  apptBook.ConfirmSection.prototype.onUpdate = function (data) {
    var me = this,
      aPgName = document.title + ' - Confirmation';

    if (data.sectionId === this.id) {
      this.confData = data.params;
      if (this.confData.counter.calendars[0].virtual === '1') {
        this.isVirtual = 1;
      }
      this.buildLessons(this.confData.services);
      if (this.isVirtual) {
        this.buildVirtualAppointmentLink(this.confData.virtual_meeting_link);
        this.container.find('.virtual-oab').removeClass('hidden');
      } else {
        this.buildLocation(this.confData.counter);
        this.container.find('.physical-oab').removeClass('hidden');
      }
      this.buildDateTime(this.confData);
      this.buildArtistName(this.confData.calendar);
    }
  };

  apptBook.ConfirmSection.prototype.buildLessons = function (data) {
    var myData, myNode, myLName, myLTime, mySeparator, myLessonUrl, myButton;

    me = this;
    this.lessons.find('.lesson').remove();
    for (var i = 0, len = data.length; i < len; i += 1) {
      myData = data[i];
      if (this.productLessonIds != '') {
        for (var j = 0; j < this.productLessonIds.length; j++) {
          if (this.productLessonIds[j] == myData.online_content_id) {
            myLessonUrl = this.productLessonUrls[j];
          }
        }
        myButton = '<a class="appt-book-link" href="' + myLessonUrl + '">' + this.productCTAText + '</a>';
      } else {
        myButton = '';
      }

      myNode = this.lesson.clone();
      myLName = myData.name;
      myLTime = myData.total_duration;
      mySeparator = i == len - 1 ? '' : this.lessonsSeparator;
      me.totalDuration += parseInt(myLTime);

      myNode.html(myLName + ' (' + myLTime + ' ' + this.minLabel + ')' + myButton + mySeparator);
      this.lessons.append(myNode);
    }
  };

  apptBook.ConfirmSection.prototype.buildVirtualAppointmentLink = function (apptLink) {
    var virtualMeetingLink = apptLink,
      apptHyperlink = this.location.find('.location-direction-links');

    if (virtualMeetingLink) {
      apptHyperlink.attr('href', virtualMeetingLink).text(virtualMeetingLink);
    }
  };

  apptBook.ConfirmSection.prototype.buildLocation = function (data) {
    var tpStr = '',
      googleStr = 'https://www.google.com/maps?daddr=',
      name = data.name,
      addr1 = data.address1,
      addr2 = data.address2,
      town = data.town,
      postCode = data.postcode,
      phone = data.phone,
      email = data.email,
      nameNode = this.location.find('.location-name'),
      addrNode = this.location.find('.location-address'),
      addr2Node = this.location.find('.location-address2'),
      townPostNode = this.location.find('.location-town-postcode'),
      phoneNode = this.location.find('.location-phone'),
      getDir = this.location.find('.location-direction-links');

    if (name) {
      nameNode.html(name);
      googleStr += name;
    } else {
      nameNode.hide();
    }

    if (addr1) {
      addrNode.html(addr1);
      googleStr += '+' + addr1;
    } else {
      addrNode.hide();
    }

    if (addr2) {
      addr2Node.html(addr2);
      googleStr += '+' + addr2;
    } else {
      addr2Node.hide();
    }

    if (town) {
      tpStr += town;
      googleStr += '+' + town;
    }

    if (oab_show_country_on_confirm) {
      if (data.county) {
        tpStr += ', ' + data.county;
        googleStr += '+' + data.county;
      }
    }
    if (postCode) {
      tpStr += tpStr === '' ? postCode : ', ' + postCode;
      googleStr += '+' + postCode;
    }

    if (tpStr === '') {
      townPostNode.hide();
    } else {
      townPostNode.html(tpStr);
    }

    if (phone) {
      phoneNode.html(phone);
    } else {
      phoneNode.hide();
    }

    getDir.attr('href', googleStr);
  };

  apptBook.ConfirmSection.prototype.buildDateTime = function (data) {
    var m, d, y, h, hSuffix, apptTimeStr, min, hcopy,
      apptDate = this.convertTimeString(data.start_time),
      apptEndDate = new Date(apptDate.getTime()),
      dateNode = this.dateTime.find('.appt-date'),
      atCopy = dateNode.text(),
      hourCopy = this.dateTime.find('.appt-hr').text(),
      me = this,
      calLocation;

    me.calContainer = me.container.find('.appt-date-cal');
    me.addCalLink = me.calContainer.find('.add-cal-link');
    me.calLinksCont = me.calContainer.find('.cals-container');
    me.calLinks = me.calContainer.find('.date-time-link');

    if (me.calContainer.length) {
      var typeClass = this.isVirtual ? '.virtual' : '.physical',
        addCalLink = me.calContainer.find('.add-cal-link'),
        calLinks = me.calContainer.find('.date-time-link'),
        addCalTitle = me.calContainer.find('.add-cal-title').html() || 'EsteeLauder Appointment',
        addCalDesc = me.calContainer.find('.add-cal-desc' + typeClass).html() || "Your Makeup Appointment is booked! Please arrive ten minutes before your lesson. We're looking forward to seeing you in person.",
        addr1 = data.counter.address1 || '',
        addr2 = data.counter.address2 || '',
        town = data.counter.town || '',
        postcode = data.counter.postcode || '',
        virtMeetingLink = data.virtual_meeting_link;

      if (this.isVirtual) {
        calLocation = site.client.isMobile ? encodeURIComponent(virtMeetingLink) : virtMeetingLink;
      } else {
        calLocation = addr1 + ', ' + town + ', ' + postcode;
      }
    }
    apptEndDate.setTime(apptEndDate.getTime() + parseInt(me.totalDuration) * 60000);
    dateNode.empty();

    m = this.months[apptDate.getMonth()];
    d = apptDate.getDate();
    y = apptDate.getFullYear();
    h = apptDate.getHours();
    min = apptDate.getMinutes();
    hSuffix = h < 12 ? 'AM' : 'PM';
    h = time_interval ? h + ':' + (min === 0 ? '00' : min) : ((h + 11) % 12 + 1) + hSuffix;
    hcopy = hourCopy ? hourCopy : 'H';
    if (special_timeformat) {
      apptTimeStr = d + ' ' + m + ' ' + y + ', ' + atCopy + ' ' + h;
    } else if (oab_override_date_format) {
      apptTimeStr = d + ' ' + m + ' ' + y + ' ' + atCopy + ' ' + h + hcopy;
    } else if (oab_hk_zh_dateformat_lang) {
      apptTimeStr = y + this.yearSuffix + (apptDate.getMonth() + 1) + this.monthSuffix + d + this.daySuffix + ' ' + h;
    } else if (oabDateFormat) {
      apptTimeStr = y + ' ' + this.yearSuffix + ' ' + (apptDate.getMonth() + 1) + ' ' + this.monthSuffix + ' ' + d + ' ' + this.daySuffix + ' ' + apptDate.getHours() + ' ' + atCopy;
    } else if (oab_date_time_override) {
      var hSuffix_tw = apptDate.getHours() < 12 ? this.amSuffix : this.pmSuffix;
      var apptHours = apptDate.getHours() % 12;

      apptHours = apptHours ? apptHours : 12;
      apptHours = apptHours < 10 ? apptHours : apptHours;
      var apptminutes = apptDate.getMinutes() < 10 ? '0' + apptDate.getMinutes() : apptDate.getMinutes();

      apptTimeStr = y + this.yearSuffix + ('0' + (apptDate.getMonth() + 1)).slice(-2) + this.monthSuffix + d + this.daySuffix + ' ' + apptHours + ':' + apptminutes + hSuffix_tw;
    } else if (oab_date_time_format_change) {
      var min_zero = min === 0 ? '00' : min;

      apptTimeStr = d + ' ' + m + ' ' + y + ' ' + atCopy + ' ' + apptDate.getHours() + ':' + min_zero;
    } else if (appointment_booking_japan_date_format) {
      apptTimeStr = y + '/' + m + '/' + d + ' ' + atCopy + ' ' + h;
    } else {
      apptTimeStr = m + ' ' + d + ', ' + y + ' ' + atCopy + ' ' + h;
    }

    dateNode.text(apptTimeStr);

    if (me.calContainer.length) {
      me.myCalendar = createCalendar({
        data: {
          device_mobile: site.client.isMobile,
          title: addCalTitle, // Event title
          start: new Date(apptDate.getTime()), // Event start date
          duration: me.totalDuration, // Event duration (IN MINUTES)
          end: new Date(apptEndDate.getTime()), // You can also choose to set an end time.
          address: calLocation,
          description: addCalDesc
        }
      });

      me.calLinks.each(function () {
        var $this = $(this);
        var calID = $(this).attr('data-cal');
        var data = $.grep(me.myCalendar, function (el, i) {
          if (el.calId.toLowerCase() === calID) {
            return el.calHref;
          }
        });
        var dataUri = data[0].calHref;

        createDownloadLink($this, dataUri, calID, 'calendar.ics');
        $this.on('click', function () {
          me.calLinksCont.toggleClass('expanded');
        });

        function createDownloadLink(anchorSelector, dataUri, calID, fileName) {
          var dateUriIE = '';
          var blobObject = null;

          if (window.navigator.msSaveOrOpenBlob && calID !== 'google') {
            dateUriIE = dataUri.split(',')[1];
            dateUriIE = decodeURIComponent(dateUriIE);
            var fileData = [dateUriIE];

            blobObject = new Blob(fileData);
            $(anchorSelector).click(function (e) {
              e.preventDefault();
              window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            });
          } else {
            $(anchorSelector).attr('href', dataUri);
          }
        }
      });
      me.addCalLink.on('click', function () {
        me.calLinksCont.toggleClass('expanded');
      });
    }
  };

  apptBook.ConfirmSection.prototype.buildArtistName = function (data) {
    var aName = data.public_name,
      aNameNode = this.artistName.find('.artist-name');

    aNameNode.html(aName);
  };

  apptBook.ConfirmSection.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  Drupal.behaviors.apptBookConfirm = {
    attach: function (context) {
      var view = new apptBook.ConfirmSection($('#confirmation'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
